import * as React from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import { useEffect, useState } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";

export default function UserList() {
  const userRef = collection(db, "users");

  const [user, setUser] = useState([]);

  useEffect(() => {
    getDocs(userRef).then((snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setUser(data);
    });
  }, []);

  return (
    <div>
      <h2>Users</h2>
      <Box sx={{ width: "50%", border: "1px solid grey", borderRadius: 3 }}>
        <List>
          {user.map((value, key) => (
            // <CategoryItem key={key} value={value} />
            <ListItem key={key} disablePadding>
              <ListItemButton>
                <ListItemText
                  primary={value.email}
                  primaryTypographyProps={{ fontSize: "14px" }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </div>
  );
}
